import { useT } from '@transifex/react'
import { UnregisterCallback } from 'history'
import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'

import { history } from '../../../store'
import Modal from '../../common/Modal'

type Props = {
  dismiss: () => void
  accept: () => void
  message?: string
}

const UserConfirmationModal = (props: Props): JSX.Element => {
  const t = useT()

  return (
    <Modal
      accept={{ action: props.accept, text: t('Leave') }}
      dismiss={{ action: props.dismiss, text: t('Stay on page') }}
      isOpen
      onHide={props.dismiss}
      title={t('Leave this page?')}
      type="dialog"
    >
      <span>{!!props.message ? props.message : t('Do you want to leave without saving your changes')}</span>
    </Modal>
  )
}

export default function getUserConfirmation(message, callback) {
  const modal = document.createElement('div')
  document.body.appendChild(modal)

  const withCleanup = (answer: boolean) => {
    ReactDOM.unmountComponentAtNode(modal)
    document.body.removeChild(modal)
    callback(answer)
  }

  ReactDOM.render(
    <UserConfirmationModal dismiss={() => withCleanup(false)} accept={() => withCleanup(true)} message={message} />,
    modal,
  )
}

export function useBlockingConfirmation(blockNavigation: boolean, message = '') {
  const unblock = useRef<UnregisterCallback>()

  useEffect(() => {
    if (blockNavigation) {
      unblock.current = history.block(message)
    }

    return () => {
      unblock.current?.()
    }
  }, [blockNavigation])
}
